import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import { COMPANY_DESC_INFO } from 'assets/json/companyInfo.js'
import IMG_6 from 'assets/images/prev_arrow.svg'
import IMG_7 from 'assets/images/next_arrow.svg'
// Import Swiper styles start
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
// Import Swiper styles end

/**
 * @file 회사소개 화면에서 desc 영역의 swiper
 */
function CompanyDescSwiper() {
    const settings = {
        className: 'swiper-describe-one swiper-box company-desc-swiper-box',
        direction: 'horizontal',
        modules: [Navigation],
        navigation: {
            // 네비게이션 적용, < >
            nextEl: '.swiper-describe-one>.slide-control-btn.next', // 다음 버튼 클래스명
            prevEl: '.swiper-describe-one>.slide-control-btn.prev', // 이전 버튼 클래스명
        },
        slidesPerView: 'auto', // 한 화면에 보이는 슬라이드 수
        spaceBetween: 50, // px 단위 간격
        loop: false,
        centeredSlides: true,
        breakpoints: {
            100: {
                centeredSlides: false,
                spaceBetween: 29,
            },
            768: {
                centeredSlides: false,
                spaceBetween: 18,
            },
            1180: {
                centeredSlides: false,
                spaceBetween: 50,
            },
        },
    }

    return (
        <Swiper {...settings}>
            <button className="slide-control-btn prev">
                <img src={IMG_6} alt="" />
            </button>
            <button className="slide-control-btn next">
                <img src={IMG_7} alt="" />
            </button>
            <div className="swiper-wrapper">
                {COMPANY_DESC_INFO.map((val, index) => (
                    <SwiperSlide className="swiper-slide" key={'company-desc-' + index}>
                        <div className="img-box" style={{ backgroundImage: `url(${val.imgUrl})` }}></div>
                        {/* <div className="text-box">
              <div className="t1"></div>
              <div className="sub"></div>
            </div> */}
                    </SwiperSlide>
                ))}
            </div>
        </Swiper>
    )
}

export default CompanyDescSwiper
